import angular from 'angular';

import FileUploadChangeDirective from './components/file-upload-change-directive';
import FileUploadComponent from './components/file-upload-input/file-upload-input-component';

export default angular
  .module('file-upload', [])
  .directive('fileUploadChange', () => new FileUploadChangeDirective())
  .component('fileUpload', new FileUploadComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/file-upload/file-upload-module.js